import { lightColorPalette } from '@linearb/linui-common';
import styled from 'styled-components';

export const StyledLoadingAlertTitle = styled.div``;

export const StyledLoadingAlertDesc = styled.div``;

export const StyledLoadingAlertIllustration = styled.img`
  position: absolute;
  bottom: -5rem;
  left: -10rem;
  width: 9rem;
  height: 9rem;
`;

export const StyledLoadingAlert = styled.div`
  box-shadow: 0px 0px 34px 0px #3b599833;
  background-color: ${lightColorPalette.lbWhite};
  padding: 1.5rem 3rem 1.5rem 8rem;
  border-radius: 8px;
  z-index: 999;

  & > main {
    position: relative;
  }
`;
